import React from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import * as actions from "../actions";
import uploadViewStateToProps from "../selectors";
import UploadLayout from "./UploadLayout";

class UploadView extends React.Component {
  static propTypes = {
    allowedOrganizations: PropTypes.arrayOf(PropTypes.string).isRequired,
    organization: PropTypes.string,
    actions: PropTypes.shape({
      validateFiles: PropTypes.func,
      removeFile: PropTypes.func,
      addFiles: PropTypes.func,
      setSelectedOrganization: PropTypes.func
    }).isRequired
  };

  static defaultProps = {
    organization: ""
  };

  constructor() {
    super();
    this.state = { anchorEl: null };
  }

  componentDidMount() {
    document.title = "Upload";

    // make an effort to auto fill organization so users don't have to set all the time
    if (this.props.organization) {
      this.props.actions.setSelectedOrganization(this.props.organization);
    } else if (this.props.allowedOrganizations.length === 1)
      this.props.actions.setSelectedOrganization(
        this.props.allowedOrganizations[0]
      );
    else if (this.props.allowedOrganizations.includes("HAKAI"))
      this.props.actions.setSelectedOrganization("HAKAI");
  }

  render() {
    return (
      <UploadLayout
        {...this.props}
        isExpanded={name => this.state[name]}
        expand={name => this.setState({ [name]: !this.state[name] })}
        handleOptionsMenuOpen={e => this.setState({ anchorEl: e.target })}
        handleOptionsMenuClose={() => this.setState({ anchorEl: null })}
        onSelectedOrganizationChange={e =>
          this.props.actions.setSelectedOrganization(e.value)
        }
        optionsMenuAnchorEl={this.state.anchorEl}
        validateFiles={() => this.props.actions.validateFiles()}
        removeFile={fileIndex => {
          this.props.actions.removeFile(fileIndex);
        }}
        addFiles={files => this.props.actions.addFiles(files)}
      />
    );
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

export default withRouter(
  connect(uploadViewStateToProps, mapDispatchToProps)(UploadView)
);
